import { groupPractices } from "../pages/Connections/connections.middleware";
import { getPractices } from "./practices.util";
import { sortArrayOfObjectsByStringKey } from "../../util/arrays";

export const getSelectedPractices = () => {
  const settings = JSON.parse(localStorage.getItem("appSettings"));
  return settings?.selectedPractices ? settings.selectedPractices : [];
};

export const getSelectedPracticesWithName = (clientId) => {
  const practices = getPractices();
  let obj = groupPractices(practices);
  const _allPractices = Object.values(obj);
  const clientPracticesSorted = sortArrayOfObjectsByStringKey(
    _allPractices,
    "clientName",
  );
  return (
    clientPracticesSorted.find((client) => client.clientId === clientId) || null
  );
};
